<template>
    <div class="cake paul">
        <img :src="'/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/cake-topper.jpg'" alt="">
    </div>
</template>

<script>
export default {
    props: {
    },
}
</script>


// WEBPACK FOOTER //
// src/components/Base/Cake.vue